module.exports = __webpack_public_path__ + "static/media/criteria-10.1.ee1ba428.jpg";